import { fetchPartnerData, fetchPartnersData } from "./actions/fetchActions";
import {
  partnersReducer,
  partnerReducer,
  createPartnerReducer,
  updatePartnerReducer,
  deletePartnerReducer,
} from "./reducers/fetchReducers";

const partnerReducers = {
  partnersGlobalStore: partnersReducer,
  partnerGlobalStore: partnerReducer,
  createPartnerGlobalStore: createPartnerReducer,
  updatePartnerGlobalStore: updatePartnerReducer,
  deletePartnerGlobalStore: deletePartnerReducer,
};

export { fetchPartnerData, fetchPartnersData, partnerReducers };
